@if (items$ | async; as items) {
<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slickConfig">
  @for (item of items; track item; let i = $index) { @if (item; as data) {
  <div ngxSlickItem class="slide">
    <div
      class="item"
      [class.outlet]="isOutlet$ | async"
      [class.has-erp-promo]="atLeastOneHasErpPromo && !showSrp"
      [class.has-hybris-promo]="atLeastOneHasHybrisPromo && !showSrp"
    >
      <a tabindex="0" (click)="goToPdp(data, $event, i + 1)">
        <span class="prod-image">
          <cx-media
            [container]="getImageRendition(data?.images?.PRIMARY)"
            format="product"
            [class.is-missing-fish]="businessType === 'fish'"
            removeImageTitleAttr
          ></cx-media>
        </span>
        <span class="prod-sku">
          {{ data.code }}
        </span>
        <span [ngClass]="['prod-name', data?.code]" [class.outlet]="isOutlet$ | async" [innerHTML]="data.name"></span>
        <span class="prod-price">
          @if (!showSrp) {
          <span class="p-label">{{ 'productCarousel.dealerPriceLabel' | cxTranslate }}</span>
          <span
            class="p-price"
            [class.erp-promo]="erpPromoValue(data?.code) && erpPromoValue(data?.code) !== '' && isOutlet$ | async"
          >
            @if (!dealerPrice(data.code)) {
            <div class="spinner-shimano-wrapper-dp">
              @if (tooltipIconConfig$ | async; as tooltipIconConfig) { @if (this.hasDealerPrice) {
              <div class="spinner-shimano">
                <div></div>
              </div>
              } @if (!hasDealerPrice && !tooltipIconConfig?.enabled) {
              <div class="no-dealer-price no-dealer-price-pcn"></div>
              } @else { @if (!hasDealerPrice && tooltipIconConfig?.enabled) {
              <app-tooltip-icon
                [noDealerPriceIcon]="tooltipIconConfig?.noDealerPriceIcon"
                dealerPriceIconContainerClass="no-dealer-price-pcn"
                [uniqueClass]="data?.code"
                placement="bottom-right"
                [tooltipContent]="'tooltip.hasNoDealerPrice' | cxTranslate"
                [closeOnScroll]="tooltipIconConfig?.closeOnScroll"
                [noPointerEventsOnElement]="tooltipIconConfig?.noPointerEventsOnElement"
                [handleEvents]="tooltipIconConfig?.handleEvents"
              ></app-tooltip-icon>
              } } }
            </div>
            } @else {
            {{ dealerPrice(data.code) }}
            @if (dealerPrice(data.code) && showGstExclusive$ | async) {
            <span class="gst-label">{{ 'cart.cartItem.gstExclusive' | cxTranslate }}</span>
            } }
          </span>
          } @if (showSrp) {
          <span class="p-label">{{ 'productCarousel.srpLabel' | cxTranslate }}</span>
          <span class="p-price"
            >{{ data.srpPrice?.formattedValue }}
            @if (data.srpPrice?.formattedValue && showGstInclusive$ | async) {
            <span class="gst-label">{{ 'cart.cartItem.gstInclusive' | cxTranslate }}</span>
            }</span
          >
          }
        </span>
        @if (dealerPrices && !showSrp && isOutlet$ | async) {
        <app-erp-promotional-text
          class="mt-auto promotional-text"
          [dealerPriceData]="dealerPriceData(data?.code)"
        ></app-erp-promotional-text>
        } @if (dealerPrices && !showSrp && isOutlet$ | async) {
        <app-promotional-text
          [productCode]="data.code"
          [product]="data"
          [promotionLocation]="'NORMALCAROUSEL'"
          [charactersLimit]="25"
        ></app-promotional-text>
        }
      </a>
    </div>
  </div>
  } }
</ngx-slick-carousel>
}
